module.exports = __webpack_public_path__ + "img/blood-pressure-log_B09M519S1Z.aae9bb9d.jpg";